export default __webpack_public_path__ + "static/7-772b62dc7df05020d4bf932b18f4fc9e.png";